import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import { BiArrowBack, BiTrash } from "react-icons/bi";
import { BsFileEarmarkExcelFill } from "react-icons/bs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  getMinPortService,
  portServiceSelector,
} from "../../master/port-service/portServiceSlice";
import { alertService } from "../../../services/AlertService";
import Loading from "../../../components/loading/Loading";
import NumberFormat from "react-number-format";

import {
  GetMonitoringQuatationSpecMin,
  getQuatationBuilder,
  insertQuatationOperasional,
  quatationOperasionalSelector,
} from "./quatationOperasionalSlice";
import {
  getMinWaste,
  WasteSelector,
} from "../../../features/master/waste-management/wasteSlice";
import {
  getMinGudang,
  gudangSelector,
} from "../../../features/master/gudang/gudangSlice";
import { getMinOum, OumSelector } from "../../../features/master/oum/oumSlice";
import {
  getMinKendaraan,
  kendaraanSelector,
} from "../../master/kendaraan/kendaraanSlice";
import {
  getMinRentalUnit,
  rentalUnitSelector,
} from "../../master/rental-unit/rentalUnitSlice";
import {
  generalServiceUnitSelector,
  getMinGeneralServiceUnit,
} from "../../master/general-service-unit/generalServiceUnitSlice";
import { getMinRental, rentalSelector } from "../../master/rental/rentalSlice";
import {
  areaRentalSelector,
  getMinAreaRental,
} from "../../master/area-rental/areaRentalSlice";

import {
  getMinLimbah,
  limbahSelector,
} from "../../../features/master/limbah/limbahSlice";
import {
  getMinRoom,
  roomSelector,
} from "../../../features/master/room/roomSlice";
import {
  getMinKlien,
  klienSelector,
} from "../../../features/master/klien/klienSlice";
import {
  getMinKemasan,
  kemasanSelector,
} from "../../../features/master/kemasan/kemasanSlice";
import {
  getMinLabour,
  labourSelector,
} from "../../../features/master/labour/labourSlice";
import { Colors } from "../../../assets/Colors";
import "./quatation.css";
import {
  CargoSelector,
  getMinCargo,
} from "../../master/cargo-carrying-unit/cargoSlice";
import { Modal, ModalBody } from "@material-tailwind/react";
import ModalHeader from "@material-tailwind/react/ModalHeader";

function isRequired(value) {
  let status = false;
  if (value !== null) {
    if (typeof value === "number") {
      if (value !== -1) {
        status = true;
      }
    }
  }
  return status;
}

function useForm(initialState = {}, validations = [], onSubmit = () => {}) {
  const { isValid: initialIsValid, errors: initialErrors } = validate(
    validations,
    initialState,
  );
  const [changed, setChanged] = useState(false);
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState(initialErrors);
  const [isValid, setValid] = useState(initialIsValid);
  const [touched, setTouched] = useState({});

  const changeHandler = (event) => {
    const newValues = { ...values, [event.target.name]: event.target.value };
    const { isValid, errors } = validate(validations, newValues);
    setChanged(true);
    setValues(newValues);
    setValid(isValid);
    setErrors(errors);
    setTouched({ ...touched, [event.target.name]: true });
  };

  const editHandler = (initValues) => {
    const newValues = {
      ...values,
      QuatationNo: initValues.QuatationNo,
      NoKontrak: initValues.NoKontrak,
    };
    setValues(newValues);
  };

  const clearHandler = () => {
    setValues(initialState);
  };

  const submitHandler = (event) => {
    event.preventDefault();
    onSubmit(values);
  };
  return {
    values,
    changeHandler,
    editHandler,
    clearHandler,
    isValid,
    errors,
    touched,
    submitHandler,
  };
}

function validate(validations, values) {
  const errors = validations
    .map((validation) => validation(values))
    .filter((validation) => typeof validation === "object");
  return {
    isValid: errors.length === 0,
    errors: errors.reduce((errors, error) => ({ ...errors, ...error }), {}),
  };
}

const QuatationPage = ({}) => {
  let initialState = {
    QuatationNo: "",
    NoKontrak: "",
  };

  const validations = [
    ({ QuatationNo }) =>
      isRequired(QuatationNo) || { QuatationNo: "Nomor Quatation wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);
  const [secondLoading, setSecondLoading] = useState(true);
  const [rentalSelect, setrentalSelector] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firstLoading, setFirstLoading] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);
  const quatation = useSelector(quatationOperasionalSelector);
  const satuan = useSelector(OumSelector);
  const klien = useSelector(klienSelector);
  const rentalUnit = useSelector(rentalUnitSelector);
  const kendaraan = useSelector(kendaraanSelector);
  const labour = useSelector(labourSelector);
  const limbah = useSelector(limbahSelector);
  const portService = useSelector(portServiceSelector);
  const waste = useSelector(WasteSelector);
  const kemasan = useSelector(kemasanSelector);
  const room = useSelector(roomSelector);
  const gudang = useSelector(gudangSelector);
  const general = useSelector(generalServiceUnitSelector);
  const rental = useSelector(rentalSelector);
  const cargo = useSelector(CargoSelector);
  const areaRental = useSelector(areaRentalSelector);
  const [showModal, setShowModal] = useState(false);
  const [load, setLoad] = useState([]);

  const [checkedState, setCheckedState] = useState(new Array(10).fill(false));
  const [data, setData] = useState({});
  const [checkListChanged, setCheckListChanged] = useState(false);

  const handleOnChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item,
    );
    let tempdata = JSON.parse(JSON.stringify(data));
    tempdata["Activity"][position]["Checked"] = updatedCheckedState[position];
    UpdateQuatationDetail(tempdata);
    setCheckedState(updatedCheckedState);
  };

  const inputArray = [
    {
      type: "text",
      id: 1,
      value: "",
    },
  ];
  const [inputArr, setInputArr] = useState(inputArray);

  let dataTemp = {};

  useEffect(() => {
    dispatch(getQuatationBuilder({}));
    dispatch(getMinOum({ search: "" }));
    dispatch(getMinKlien({ search: "" }));
    dispatch(getMinRentalUnit({ search: "" }));
    dispatch(getMinKendaraan({ search: "" }));
    dispatch(getMinLabour({ search: "" }));
    dispatch(getMinLimbah({ search: "" }));
    dispatch(getMinPortService());
    dispatch(getMinWaste({ search: "" }));
    dispatch(getMinKemasan({ search: "" }));
    dispatch(getMinRoom({ search: "" }));
    dispatch(getMinGudang({ search: "" }));
    dispatch(getMinGeneralServiceUnit({ search: "" }));
    dispatch(getMinRental({ search: "" }));
    dispatch(getMinCargo({ search: "" }));
    dispatch(getMinAreaRental({ search: "" }));
    dispatch(GetMonitoringQuatationSpecMin({}));
  }, []);

  useEffect(() => {
    if (quatation.isGetBuilderSuccess && !data["Activity"]) {
      dataTemp = quatation.dataBuilder;
      setData(quatation.dataBuilder);
    }

    if (updateFetch) {
      setUpdateFetch(false);
      if (quatation.isUpdateSuccess) {
        alertService.success(quatation.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
      }
    }

    if (quatation.isGetBuilderSuccess && firstLoading === false) {
      setFirstLoading(true);
    }
    if (quatation.isInsertSuccess) {
      setSecondLoading(true);
      navigate("/monitoring-additional-quotation-or-contract");
    }
  });

  function UpdateQuatationDetail(dataArr) {
    setData(dataArr);
  }

  function handleInsertQuatation() {
    setSecondLoading(false);
    let tempdata = JSON.parse(JSON.stringify(data));
    tempdata["Jenis"] = "2";
    dispatch(insertQuatationOperasional(tempdata));
  }

  function handleInsertEquipment() {
    let tempdata = JSON.parse(JSON.stringify(data));
    const Equipment = {
      Unit: "",
      Satuan: "",
      MinUsage: 0,
      Rate: 0,
    };
    if (!tempdata.Equipment) {
      tempdata.Equipment = [];
    }
    tempdata.Equipment.push(Equipment);
    UpdateQuatationDetail(tempdata);
  }

  function deleteEquipment(i) {
    let tempdata = JSON.parse(JSON.stringify(data));
    tempdata.Equipment.splice(i, 1);
    UpdateQuatationDetail(tempdata);
  }

  function handleInsertLabour() {
    let tempdata = JSON.parse(JSON.stringify(data));
    const Labour = {
      Labour: "",
      Satuan: "",
      MinUsage: 0,
      Rate: 0,
    };
    if (!tempdata.Labour) {
      tempdata.Labour = [];
    }
    tempdata.Labour.push(Labour);
    UpdateQuatationDetail(tempdata);
  }

  function deleteLabour(i) {
    let tempdata = JSON.parse(JSON.stringify(data));
    tempdata.Labour.splice(i, 1);
    UpdateQuatationDetail(tempdata);
  }

  function deleteTws(i) {
    let tempdata = JSON.parse(JSON.stringify(data));
    tempdata.Tws.splice(i, 1);
    UpdateQuatationDetail(tempdata);
  }

  function handleInsertTws() {
    let tempdata = JSON.parse(JSON.stringify(data));
    const Tws = {
      Description: "",
      TypeOfPackage: "",
      Unit: "",
      MinUsage: 0,
      Rate: 0,
    };
    if (!tempdata.Tws) {
      tempdata.Tws = [];
    }
    tempdata.Tws.push(Tws);
    UpdateQuatationDetail(tempdata);
  }

  function deleteTruck(i) {
    let tempdata = JSON.parse(JSON.stringify(data));
    tempdata.Truck.splice(i, 1);
    UpdateQuatationDetail(tempdata);
  }

  function handleInsertTruck() {
    let tempdata = JSON.parse(JSON.stringify(data));
    const Truck = {
      Description: "",
      Transporter: "",
      UnitNumber: "",
      MinUsage: 0,
      Rate: 0,
    };
    if (!tempdata.Truck) {
      tempdata.Truck = [];
    }
    tempdata.Truck.push(Truck);
    UpdateQuatationDetail(tempdata);
  }

  const meals = [
    { value: "Breakfast", label: "BreakFast" },
    { value: "Lunch", label: "Lunch" },
    { value: "Dinner", label: "Dinner" },
    { value: "Breakfast, Lunch", label: "Breakfast, Lunch" },
    { value: "Breakfast, Lunch, Dinner", label: "Breakfast, Lunch, Dinner" },
    { value: "Lunch, Dinner", label: "Lunch, Dinner" },
  ];

  const acomodation = [
    { value: "Accomodation/Room", label: "Accomodation/Room" },
    { value: "Laundry", label: "Laundry" },
  ];
  const wooden = [
    { value: "Wooden Dunnage", label: "Wooden Dunnage" },
    { value: "Pallet Wrapping", label: "Pallet Wrapping" },
  ];
  const drill = [
    { value: "Drill Water", label: "Drill Water" },
    { value: "Fresh Water", label: "Fresh Water" },
  ];
  const others = [
    { value: "Fuel", label: "Fuel" },
    { value: "Document Cleance", label: "Document Cleance" },
    { value: "Material Supply", label: "Material Supply" },
  ];

  // Opsi Port Services diambil dari master "MPortService" (dulu daftar hardcode
  // sepanjang 19 baris tepat di sini — salinan KEDUA dari daftar yang sama).
  // Menambah layanan kini cukup lewat master, tanpa menyentuh dua halaman ini.
  const port_service = portService.minData ?? [];

  // Nilai tersimpan yang tak ada di daftar aktif tetap dirender dari Surname yang
  // sudah tersimpan, supaya QO lama tak tampil kosong lalu kehilangan pilihannya
  // saat disimpan ulang.
  const portServiceValue = (name, surname) => {
    if (!name) return null;
    return (
      port_service.find((o) => o.value === name) ?? {
        value: name,
        label: surname || name,
      }
    );
  };

  function deleteWSM(i, z) {
    let tempdata = JSON.parse(JSON.stringify(data));
    tempdata.Activity[z].DetailActivity.splice(i, 1);
    UpdateQuatationDetail(tempdata);
  }

  function handleInsertWSM(i) {
    let tempdata = JSON.parse(JSON.stringify(data));
    const Tws = {
      Category: "",
      Checked: false,
      DetailUnit: "",
      Min_Usage: "0",
      Name: "",
      Rate: "0",
      SatuanID: "",
      writable: true,
    };
    if (!tempdata.Activity[i].DetailActivity) {
      tempdata.Activity[i].DetailActivity = [];
    }
    tempdata.Activity[i].DetailActivity.push(Tws);
    UpdateQuatationDetail(tempdata);
  }

  function deleteGM(i) {
    let tempdata = JSON.parse(JSON.stringify(data));
    tempdata.Activity[5].DetailActivity.splice(i, 1);
    UpdateQuatationDetail(tempdata);
  }

  function handleInsertGM(Kategory) {
    let tempdata = JSON.parse(JSON.stringify(data));
    const Tws = {
      Category: "",
      Checked: false,
      DetailUnit: Kategory,
      Min_Usage: "0",
      Name: "",
      Rate: "0",
      SatuanID: "",
      writable: true,
    };
    if (!tempdata.Activity[5].DetailActivity) {
      tempdata.Activity[5].DetailActivity = [];
    }
    tempdata.Activity[5].DetailActivity.push(Tws);
    UpdateQuatationDetail(tempdata);
  }

  function handleLoad() {
    let items = JSON.parse(localStorage.getItem("QuotataionSaveData"));
    setLoad(items);
    setShowModal(true);
  }

  function handleLoadData(datas) {
    let tempdata = JSON.parse(JSON.stringify(datas.Data));
    UpdateQuatationDetail(tempdata);
    setShowModal(false);
    let updatedCheckedState = checkedState;
    tempdata.Activity &&
      tempdata.Activity.map((datae, id) => {
        if (datae.Checked) {
          updatedCheckedState[id] = true;
        } else {
          updatedCheckedState[id] = false;
        }
      });
    setCheckedState(updatedCheckedState);
    if (updatedCheckedState[0] || updatedCheckedState[4]) {
      let picker = [];
      if (updatedCheckedState[0]) {
        picker.push("1");
      }
      if (updatedCheckedState[4]) {
        picker.push("2");
      }
      const res = kendaraan.minData.filter((e) =>
        picker.includes(e.CategoryID),
      );
      const res2 = satuan.minData.filter((e) => picker.includes(e.CategoryID));
    }
  }

  function handleSave() {
    let tempdata = JSON.parse(JSON.stringify(data));
    let items = JSON.parse(localStorage.getItem("QuotataionSaveData"));

    if (!items) {
      items = [];
    }
    if (items.length > 10) {
      items = items.slice(Math.max(items.length - 5, 1));
    }
    let savedata = [...items, { SaveDate: new Date(), Data: tempdata }];
    localStorage.setItem("QuotataionSaveData", JSON.stringify(savedata));
  }

  if (!firstLoading || !secondLoading) {
    return <Loading />;
  } else {
    return (
      <>
        <div className="md:ml-64">
          <div className="flex w-full justify-between px-4 flex-col sm:flex-row pt-4">
            <button
              onClick={() =>
                navigate("/monitoring-additional-quotation-or-contract")
              }
              className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
            >
              <BiArrowBack className="text-xl text-gray-800 pr-2" />
              Back
            </button>
            <div className="flex w-full justify-end ">
              <button
                color={isValid ? "green" : "blueGray"}
                ripple={isValid ? "light" : ""}
                onClick={() => {
                  handleLoad();
                }}
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded "
              >
                Load
              </button>
              <button
                color={isValid ? "green" : "blueGray"}
                ripple={isValid ? "light" : ""}
                onClick={() => {
                  handleSave();
                }}
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded "
              >
                Save
              </button>
              <button
                onClick={() => handleInsertQuatation()}
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
              >
                Simpan
              </button>
            </div>
          </div>

          <div className="px-4 py-4">
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-1/2 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Quotation or contract
                </label>
                <Select
                  menuPortalTarget={document.body}
                  value={quatation.mindata.filter(
                    ({ value }) => value === data.QuatationParent,
                  )}
                  onChange={(e) => {
                    let tempdata = JSON.parse(JSON.stringify(data));
                    tempdata["QuatationParent"] = e.value;
                    UpdateQuatationDetail(tempdata);
                  }}
                  options={quatation.mindata}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-1/2 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Number contract
                </label>
                <input
                  value={data.NoKontrak}
                  name="NoKontrak"
                  className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  type="text"
                  onChange={(e) => {
                    let tempdata = JSON.parse(JSON.stringify(data));
                    tempdata["NoKontrak"] = e.target.value;
                    UpdateQuatationDetail(tempdata);
                  }}
                />
              </div>

              <div className="w-1/2 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Expire Date
                </label>
                <DatePicker
                  className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  selected={
                    data.ExpireDate
                      ? new Date(data.ExpireDate)
                      : data.ExpireDate === ""
                        ? ""
                        : new Date()
                  }
                  onChange={(date) => {
                    let tempdata = JSON.parse(JSON.stringify(data));
                    tempdata["ExpireDate"] = date;
                    UpdateQuatationDetail(tempdata);
                  }}
                />
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-1/2 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Client
                </label>
                <div className="inline-block relative w-full  ">
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      klien.minData &&
                      klien.minData.filter(
                        ({ value }) => value === data.KlienID,
                      )
                    }
                    onChange={(e) => {
                      let tempdata = JSON.parse(JSON.stringify(data));
                      tempdata["KlienID"] = e.value;
                      UpdateQuatationDetail(tempdata);
                    }}
                    options={klien.minData}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Work Desc
                </label>
                <input
                  value={data.WorkDesc}
                  name="WorkDesc"
                  className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  type="text"
                  onChange={(e) => {
                    let tempdata = JSON.parse(JSON.stringify(data));
                    tempdata["WorkDesc"] = e.target.value;
                    UpdateQuatationDetail(tempdata);
                  }}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 ">
              <div className="w-full px-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Activity Choice
                </label>
              </div>
            </div>
            <div className="flex flex-wrap mx-3 mb-3">
              <div className="w-full px-3">
                <div className="flex flex-wrap -mx-3">
                  {quatation.dataBuilder.Activity.map(
                    ({ Name, Checked, DetailActivity }, index) => {
                      return (
                        <div className="w-1/3 px-3">
                          <div className="w-full px-3">
                            <div className="flex flex-wrap -mx-3 mb-3">
                              <input
                                checked={checkedState[index]}
                                type="checkbox"
                                id={`custom-checkbox-${index}`}
                                onClick={() => {
                                  handleOnChange(index);
                                  setCheckListChanged(true);
                                }}
                                className="mr-2 mt-1"
                              />
                              <label htmlFor={`custom-checkbox-${index}`}>
                                {Name.replace(/[_]/g, " ")}
                              </label>
                            </div>
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 ">
              <div className="w-full px-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Activity
                </label>
              </div>
            </div>
            {data.Activity &&
              data.Activity.map(({ Name, Checked, DetailActivity }, index) => {
                let Category = "1";
                switch (Name) {
                  case "PORT_SERVICES":
                    Category = "1";
                    break;
                  case "RENTAL":
                    Category = "2";
                    break;
                  case "WASTE_MANAGEMENT_SERVICES":
                    Category = "3";
                    break;
                  case "AREA_RENTAL":
                    Category = "4";
                    break;
                }
                if (checkedState[index])
                  if (Name !== "GENERAL_SERVICE") {
                    return (
                      <>
                        <div
                          key={index}
                          className="flex flex-wrap -mx-3 px-3 mb-6 "
                        >
                          <div
                            style={{
                              background: checkedState[index] && Colors.primary,
                            }}
                            className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-white `}
                          >
                            {Name.replace(/[_]/g, " ").toLowerCase()}
                          </div>
                          {checkedState[index] && (
                            <Card className="flex flex-col items-center content-center rounded-t-none">
                              <>
                                <CardBody className="w-full pt-0 ">
                                  <div className="overflow-x-auto">
                                    <button
                                      onClick={() => handleInsertWSM(index)}
                                      className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                    >
                                      Add
                                    </button>
                                  </div>

                                  <div className="overflow-x-auto">
                                    <table className="table-auto w-full bg-transparent border-collapse">
                                      <thead>
                                        <tr>
                                          <>
                                            <th></th>
                                          </>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Description
                                          </th>
                                          {Name ===
                                            "WASTE_MANAGEMENT_SERVICES" && (
                                            <>
                                              <th
                                                style={{
                                                  color: Colors.primary,
                                                }}
                                                className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                              >
                                                Haz. Waste Code
                                              </th>
                                              <th
                                                style={{
                                                  color: Colors.primary,
                                                }}
                                                className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                              >
                                                Waste Description
                                              </th>
                                            </>
                                          )}
                                          {Name === "AREA_RENTAL" && (
                                            <>
                                              <th
                                                style={{
                                                  color: Colors.primary,
                                                }}
                                                className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                              >
                                                Kelompok
                                              </th>
                                            </>
                                          )}
                                          {Name === "RENTAL" && (
                                            <th
                                              style={{
                                                color: Colors.primary,
                                              }}
                                              className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                            >
                                              Detail Unit
                                            </th>
                                          )}

                                          <th
                                            style={{ color: Colors.primary }}
                                            className="w-1/6 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Unit
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Min Usage
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Rate
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {DetailActivity &&
                                          DetailActivity.map((keyName, i) => (
                                            <tr key={keyName + i}>
                                              <th>
                                                <button
                                                  onClick={() =>
                                                    deleteWSM(i, index)
                                                  }
                                                  className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                                >
                                                  <BiTrash className="text-xl text-red-800" />
                                                </button>
                                              </th>

                                              {Name === "RENTAL" && (
                                                <>
                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    {keyName["Category"] ===
                                                      "1" && "Heavy Equipment"}
                                                    {keyName["Category"] ===
                                                      "2" &&
                                                      "Lifting Rigging Equipment"}
                                                    {keyName["Category"] ===
                                                      "3" &&
                                                      "Cargo Carrying Unit"}
                                                    {keyName["Category"] ===
                                                      "" && "-"}
                                                  </th>
                                                </>
                                              )}
                                              {/*{Name !==*/}
                                              {/*    "WASTE_MANAGEMENT_SERVICES" && (*/}
                                              {/*        <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">*/}
                                              {/*            {keyName["Name"].replace(*/}
                                              {/*                /[_]/g,*/}
                                              {/*                " "*/}
                                              {/*            )}*/}
                                              {/*        </th>*/}
                                              {/*    )}*/}
                                              {Name ===
                                                "WASTE_MANAGEMENT_SERVICES" && (
                                                <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                  <div className="inline-block relative w-full  ">
                                                    <Select
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      value={waste.minData.filter(
                                                        ({ value }) =>
                                                          value ===
                                                          keyName["Name"],
                                                      )}
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Name"
                                                        ] = e.value;
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Surname"
                                                        ] = e.label;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                      options={waste.minData}
                                                    />
                                                  </div>
                                                </th>
                                              )}
                                              {Name === "PORT_SERVICES" && (
                                                <th className="border-b w-1/3 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                  <div
                                                    className={
                                                      data["Activity"][index][
                                                        "DetailActivity"
                                                      ][i]["Name"] ===
                                                      "Vessel_Service"
                                                        ? "inline-block relative w-1/2"
                                                        : "inline-block relative w-full"
                                                    }
                                                  >
                                                    <Select
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      value={portServiceValue(
                                                        keyName["Name"],
                                                        keyName["Surname"],
                                                      )}
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Name"
                                                        ] = e.value;
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Surname"
                                                        ] = e.label;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                      options={port_service}
                                                    />
                                                  </div>
                                                  {data["Activity"][index][
                                                    "DetailActivity"
                                                  ][i]["Name"] ===
                                                    "Vessel_Berthing" && (
                                                    <div className="inline-block relative w-1/2   ">
                                                      <input
                                                        type="text"
                                                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                        value={
                                                          data["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Surname"]
                                                        }
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Surname"] =
                                                            e.target.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  )}
                                                </th>
                                              )}
                                              {Name === "RENTAL" && (
                                                <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                  <div className="inline-block relative w-full  ">
                                                    <Select
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      value={rentalSelect.filter(
                                                        ({ value }) =>
                                                          value ===
                                                          keyName["Name"],
                                                      )}
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Category"
                                                        ] = e.CategoryID;

                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Name"
                                                        ] = e.value;
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Surname"
                                                        ] = e.label;

                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                      options={rentalSelect}
                                                    />
                                                  </div>
                                                </th>
                                              )}
                                              {Name === "AREA_RENTAL" && (
                                                <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                  <div className="inline-block relative w-full  ">
                                                    <Select
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      value={areaRental.minData.filter(
                                                        ({ value }) =>
                                                          value ===
                                                          keyName["Name"],
                                                      )}
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Category"
                                                        ] = e.CategoryID;

                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Name"
                                                        ] = e.value;
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Surname"
                                                        ] = e.label;

                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                      options={
                                                        areaRental.minData
                                                      }
                                                    />
                                                  </div>
                                                </th>
                                              )}
                                              {Name === "MANPOWER" && (
                                                <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                  <div className="inline-block relative w-full  ">
                                                    <Select
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      value={labour.minData.filter(
                                                        ({ value }) =>
                                                          value ===
                                                          keyName["Name"],
                                                      )}
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );

                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Name"
                                                        ] = e.value;
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Surname"
                                                        ] = e.label;

                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                      options={labour.minData}
                                                    />
                                                  </div>
                                                </th>
                                              )}
                                              {Name === "AREA_RENTAL" && (
                                                <>
                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    {keyName["Category"] ===
                                                      "1" && "Area Rental"}
                                                    {keyName["Category"] ===
                                                      "2" &&
                                                      "Pusat Logistic Berikat"}
                                                    {keyName["Category"] ===
                                                      "3" &&
                                                      "Tubular Inspection Shop"}
                                                    {keyName["Category"] ===
                                                      "" && "-"}
                                                  </th>
                                                </>
                                              )}
                                              {Name ===
                                                "WASTE_MANAGEMENT_SERVICES" && (
                                                <>
                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={limbah.minDataKode.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            data["Activity"][
                                                              index
                                                            ]["DetailActivity"][
                                                              i
                                                            ]["DetailUnit"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["DetailUnit"] =
                                                            e.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={
                                                          limbah.minDataKode
                                                        }
                                                      />
                                                    </div>
                                                  </th>
                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={limbah.minData.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            data["Activity"][
                                                              index
                                                            ]["DetailActivity"][
                                                              i
                                                            ]["DetailUnit"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["DetailUnit"] =
                                                            e.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={limbah.minData}
                                                      />
                                                    </div>
                                                  </th>
                                                </>
                                              )}

                                              <th className="border-b w-1/4 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                <div className="inline-block relative w-full  ">
                                                  <Select
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    value={satuan.minData.filter(
                                                      ({ value }) =>
                                                        value ===
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["SatuanID"],
                                                    )}
                                                    onChange={(e) => {
                                                      let tempdata = JSON.parse(
                                                        JSON.stringify(data),
                                                      );
                                                      tempdata["Activity"][
                                                        index
                                                      ]["DetailActivity"][i][
                                                        "SatuanID"
                                                      ] = e.value;
                                                      UpdateQuatationDetail(
                                                        tempdata,
                                                      );
                                                    }}
                                                    options={satuan.minData.filter(
                                                      ({ CategoryID }) =>
                                                        CategoryID === Category,
                                                    )}
                                                  />
                                                </div>
                                              </th>
                                              <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                <input
                                                  type="text"
                                                  value={
                                                    data["Activity"][index][
                                                      "DetailActivity"
                                                    ][i]["Min_Usage"]
                                                  }
                                                  onChange={(e) => {
                                                    let tempdata = JSON.parse(
                                                      JSON.stringify(data),
                                                    );
                                                    tempdata["Activity"][index][
                                                      "DetailActivity"
                                                    ][i]["Min_Usage"] =
                                                      e.target.value;
                                                    UpdateQuatationDetail(
                                                      tempdata,
                                                    );
                                                  }}
                                                />
                                              </th>

                                              <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                <NumberFormat
                                                  value={
                                                    data["Activity"][index][
                                                      "DetailActivity"
                                                    ][i]["Rate"]
                                                  }
                                                  thousandSeparator={true}
                                                  onValueChange={(values) => {
                                                    const {
                                                      formattedValue,
                                                      value,
                                                    } = values;
                                                    let tempdata = JSON.parse(
                                                      JSON.stringify(data),
                                                    );
                                                    tempdata["Activity"][index][
                                                      "DetailActivity"
                                                    ][i]["Rate"] = value;
                                                    UpdateQuatationDetail(
                                                      tempdata,
                                                    );
                                                  }}
                                                />
                                              </th>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                                {quatation.dataBuilder.Activity
                                  .DetailActivity && (
                                  <div className="w-full flex flex-col justify-center items-center">
                                    <BsFileEarmarkExcelFill className="text-7xl py-2 text-gray-400" />
                                    <div className="pb-4 text-gray-800">
                                      Data tidak ditemukan
                                    </div>
                                  </div>
                                )}
                              </>
                            </Card>
                          )}
                        </div>
                      </>
                    );
                  } else {
                    return (
                      <>
                        <div
                          key={index}
                          className="flex flex-wrap -mx-3 px-3 mb-6 "
                        >
                          <div
                            style={{
                              background: checkedState[index] && Colors.primary,
                            }}
                            className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-white `}
                          >
                            Accomodation & Laundry
                          </div>
                          <>
                            <Card className="flex flex-col items-center content-center rounded-t-none">
                              <>
                                <CardBody className="w-full pt-0 ">
                                  <div className="overflow-x-auto">
                                    <button
                                      onClick={() => handleInsertGM("ROOM")}
                                      className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                    >
                                      Add
                                    </button>
                                  </div>
                                  <div className="overflow-x-auto">
                                    <table className="table-auto w-full bg-transparent border-collapse">
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Activity
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Room No.
                                          </th>

                                          <th
                                            style={{ color: Colors.primary }}
                                            className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Unit
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Min Usage
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Rate
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {DetailActivity &&
                                          DetailActivity.map((keyName, i) => {
                                            if (
                                              keyName["DetailUnit"] === "ROOM"
                                            )
                                              return (
                                                <tr key={keyName + i}>
                                                  <th>
                                                    <button
                                                      onClick={() =>
                                                        deleteGM(i)
                                                      }
                                                      className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                                    >
                                                      <BiTrash className="text-xl text-red-800" />
                                                    </button>
                                                  </th>
                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={acomodation.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            keyName["Name"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Name"] = e.value;
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Surname"] =
                                                            e.label;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={acomodation}
                                                      />
                                                    </div>
                                                  </th>

                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={room.minData.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            keyName["Category"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Category"] =
                                                            e.value;

                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={room.minData}
                                                      />
                                                    </div>
                                                  </th>

                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={satuan.minData.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            data["Activity"][
                                                              index
                                                            ]["DetailActivity"][
                                                              i
                                                            ]["SatuanID"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["SatuanID"] =
                                                            e.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={satuan.minData.filter(
                                                          ({ CategoryID }) =>
                                                            CategoryID === "5",
                                                        )}
                                                      />
                                                    </div>
                                                  </th>
                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <input
                                                      type="text"
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Min_Usage"]
                                                      }
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Min_Usage"
                                                        ] = e.target.value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>
                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <NumberFormat
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Rate"]
                                                      }
                                                      thousandSeparator={true}
                                                      onValueChange={(
                                                        values,
                                                      ) => {
                                                        const {
                                                          formattedValue,
                                                          value,
                                                        } = values;
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Rate"
                                                        ] = value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>
                                                </tr>
                                              );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                                {quatation.dataBuilder.Activity
                                  .DetailActivity && (
                                  <div className="w-full flex flex-col justify-center items-center">
                                    <BsFileEarmarkExcelFill className="text-7xl py-2 text-gray-400" />
                                    <div className="pb-4 text-gray-800">
                                      Data tidak ditemukan
                                    </div>
                                  </div>
                                )}
                              </>
                            </Card>
                          </>
                        </div>

                        <div
                          key={index}
                          className="flex flex-wrap -mx-3 px-3 mb-6 "
                        >
                          <div
                            style={{
                              background: checkedState[index] && Colors.primary,
                            }}
                            className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-white `}
                          >
                            Meals
                          </div>
                          <>
                            <Card className="flex flex-col items-center content-center rounded-t-none">
                              <>
                                <CardBody className="w-full pt-0 ">
                                  <div className="overflow-x-auto">
                                    <button
                                      onClick={() => handleInsertGM("MEALS")}
                                      className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                    >
                                      Add
                                    </button>
                                  </div>
                                  <div className="overflow-x-auto">
                                    <table className="table-auto w-full bg-transparent border-collapse">
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Meals
                                          </th>

                                          <th
                                            style={{ color: Colors.primary }}
                                            className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Unit
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Min Usage
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Rate
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {DetailActivity &&
                                          DetailActivity.map((keyName, i) => {
                                            if (
                                              keyName["DetailUnit"] === "MEALS"
                                            )
                                              return (
                                                <tr key={keyName + i}>
                                                  <th>
                                                    <button
                                                      onClick={() =>
                                                        deleteGM(i)
                                                      }
                                                      className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                                    >
                                                      <BiTrash className="text-xl text-red-800" />
                                                    </button>
                                                  </th>

                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={meals.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            keyName["Name"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Name"] = e.value;
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Surname"] =
                                                            e.label;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={meals}
                                                      />
                                                    </div>
                                                  </th>

                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={satuan.minData.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            data["Activity"][
                                                              index
                                                            ]["DetailActivity"][
                                                              i
                                                            ]["SatuanID"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["SatuanID"] =
                                                            e.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={satuan.minData.filter(
                                                          ({ CategoryID }) =>
                                                            CategoryID === "5",
                                                        )}
                                                      />
                                                    </div>
                                                  </th>
                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <input
                                                      type="text"
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Min_Usage"]
                                                      }
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Min_Usage"
                                                        ] = e.target.value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>

                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <NumberFormat
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Rate"]
                                                      }
                                                      thousandSeparator={true}
                                                      onValueChange={(
                                                        values,
                                                      ) => {
                                                        const {
                                                          formattedValue,
                                                          value,
                                                        } = values;
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Rate"
                                                        ] = value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>
                                                </tr>
                                              );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                                {quatation.dataBuilder.Activity
                                  .DetailActivity && (
                                  <div className="w-full flex flex-col justify-center items-center">
                                    <BsFileEarmarkExcelFill className="text-7xl py-2 text-gray-400" />
                                    <div className="pb-4 text-gray-800">
                                      Data tidak ditemukan
                                    </div>
                                  </div>
                                )}
                              </>
                            </Card>
                          </>
                        </div>

                        <div
                          key={index}
                          className="flex flex-wrap -mx-3 px-3 mb-6 "
                        >
                          <div
                            style={{
                              background: checkedState[index] && Colors.primary,
                            }}
                            className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-white `}
                          >
                            Wooden Dunnage & Pallet Wraping
                          </div>
                          <>
                            <Card className="flex flex-col items-center content-center rounded-t-none">
                              <>
                                <CardBody className="w-full pt-0 ">
                                  <div className="overflow-x-auto">
                                    <button
                                      onClick={() => handleInsertGM("WOODEN")}
                                      className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                    >
                                      Add
                                    </button>
                                  </div>
                                  <div className="overflow-x-auto">
                                    <table className="table-auto w-full bg-transparent border-collapse">
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Activity
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Location Used
                                          </th>

                                          <th
                                            style={{ color: Colors.primary }}
                                            className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Unit
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Min Usage
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Rate
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {DetailActivity &&
                                          DetailActivity.map((keyName, i) => {
                                            if (
                                              keyName["DetailUnit"] === "WOODEN"
                                            )
                                              return (
                                                <tr key={keyName + i}>
                                                  <th>
                                                    <button
                                                      onClick={() =>
                                                        deleteGM(i)
                                                      }
                                                      className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                                    >
                                                      <BiTrash className="text-xl text-red-800" />
                                                    </button>
                                                  </th>
                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={wooden.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            keyName["Name"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Name"] = e.value;
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Surname"] =
                                                            e.label;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={wooden}
                                                      />
                                                    </div>
                                                  </th>
                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={gudang.minData.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            keyName["Category"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Category"] =
                                                            e.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={gudang.minData}
                                                      />
                                                    </div>
                                                  </th>

                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={satuan.minData.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            data["Activity"][
                                                              index
                                                            ]["DetailActivity"][
                                                              i
                                                            ]["SatuanID"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["SatuanID"] =
                                                            e.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={satuan.minData.filter(
                                                          ({ CategoryID }) =>
                                                            CategoryID === "5",
                                                        )}
                                                      />
                                                    </div>
                                                  </th>
                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <input
                                                      type="text"
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Min_Usage"]
                                                      }
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Min_Usage"
                                                        ] = e.target.value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>

                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <NumberFormat
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Rate"]
                                                      }
                                                      thousandSeparator={true}
                                                      onValueChange={(
                                                        values,
                                                      ) => {
                                                        const {
                                                          formattedValue,
                                                          value,
                                                        } = values;
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Rate"
                                                        ] = value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>
                                                </tr>
                                              );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                                {quatation.dataBuilder.Activity
                                  .DetailActivity && (
                                  <div className="w-full flex flex-col justify-center items-center">
                                    <BsFileEarmarkExcelFill className="text-7xl py-2 text-gray-400" />
                                    <div className="pb-4 text-gray-800">
                                      Data tidak ditemukan
                                    </div>
                                  </div>
                                )}
                              </>
                            </Card>
                          </>
                        </div>
                        <div
                          key={index}
                          className="flex flex-wrap -mx-3 px-3 mb-6 "
                        >
                          <div
                            style={{
                              background: checkedState[index] && Colors.primary,
                            }}
                            className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-white `}
                          >
                            Drill & Fresh Water
                          </div>
                          <>
                            <Card className="flex flex-col items-center content-center rounded-t-none">
                              <>
                                <CardBody className="w-full pt-0 ">
                                  <div className="overflow-x-auto">
                                    <button
                                      onClick={() => handleInsertGM("Drill")}
                                      className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                    >
                                      Add
                                    </button>
                                  </div>
                                  <div className="overflow-x-auto">
                                    <table className="table-auto w-full bg-transparent border-collapse">
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Activity
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Description
                                          </th>

                                          <th
                                            style={{ color: Colors.primary }}
                                            className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Unit
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Min Usage
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Rate
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {DetailActivity &&
                                          DetailActivity.map((keyName, i) => {
                                            if (
                                              keyName["DetailUnit"] === "Drill"
                                            )
                                              return (
                                                <tr key={keyName + i}>
                                                  <th>
                                                    <button
                                                      onClick={() =>
                                                        deleteGM(i)
                                                      }
                                                      className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                                    >
                                                      <BiTrash className="text-xl text-red-800" />
                                                    </button>
                                                  </th>
                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={drill.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            keyName["Name"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Name"] = e.value;
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Surname"] =
                                                            e.label;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={drill}
                                                      />
                                                    </div>
                                                  </th>

                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <input
                                                        type="text"
                                                        value={
                                                          data["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Category"]
                                                        }
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Category"] =
                                                            e.target.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  </th>

                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={satuan.minData.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            data["Activity"][
                                                              index
                                                            ]["DetailActivity"][
                                                              i
                                                            ]["SatuanID"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["SatuanID"] =
                                                            e.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={satuan.minData.filter(
                                                          ({ CategoryID }) =>
                                                            CategoryID === "5",
                                                        )}
                                                      />
                                                    </div>
                                                  </th>
                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <input
                                                      type="text"
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Min_Usage"]
                                                      }
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Min_Usage"
                                                        ] = e.target.value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>

                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <NumberFormat
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Rate"]
                                                      }
                                                      thousandSeparator={true}
                                                      onValueChange={(
                                                        values,
                                                      ) => {
                                                        const {
                                                          formattedValue,
                                                          value,
                                                        } = values;
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Rate"
                                                        ] = value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>
                                                </tr>
                                              );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                                {quatation.dataBuilder.Activity
                                  .DetailActivity && (
                                  <div className="w-full flex flex-col justify-center items-center">
                                    <BsFileEarmarkExcelFill className="text-7xl py-2 text-gray-400" />
                                    <div className="pb-4 text-gray-800">
                                      Data tidak ditemukan
                                    </div>
                                  </div>
                                )}
                              </>
                            </Card>
                          </>
                        </div>

                        <div
                          key={index}
                          className="flex flex-wrap -mx-3 px-3 mb-6 "
                        >
                          <div
                            style={{
                              background: checkedState[index] && Colors.primary,
                            }}
                            className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-white `}
                          >
                            Others Service
                          </div>
                          <>
                            <Card className="flex flex-col items-center content-center rounded-t-none">
                              <>
                                <CardBody className="w-full pt-0 ">
                                  <div className="overflow-x-auto">
                                    <button
                                      onClick={() => handleInsertGM("Others")}
                                      className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                    >
                                      Add
                                    </button>
                                  </div>
                                  <div className="overflow-x-auto">
                                    <table className="table-auto w-full bg-transparent border-collapse">
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Activity
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Description
                                          </th>

                                          <th
                                            style={{ color: Colors.primary }}
                                            className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Unit
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Min Usage
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Rate
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {DetailActivity &&
                                          DetailActivity.map((keyName, i) => {
                                            if (
                                              keyName["DetailUnit"] === "Others"
                                            )
                                              return (
                                                <tr key={keyName + i}>
                                                  <th>
                                                    <button
                                                      onClick={() =>
                                                        deleteGM(i)
                                                      }
                                                      className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                                    >
                                                      <BiTrash className="text-xl text-red-800" />
                                                    </button>
                                                  </th>
                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={others.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            keyName["Name"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Name"] = e.value;
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Surname"] =
                                                            e.label;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={others}
                                                      />
                                                    </div>
                                                  </th>

                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <input
                                                        type="text"
                                                        value={
                                                          data["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Category"]
                                                        }
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Category"] =
                                                            e.target.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  </th>

                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={satuan.minData.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            data["Activity"][
                                                              index
                                                            ]["DetailActivity"][
                                                              i
                                                            ]["SatuanID"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["SatuanID"] =
                                                            e.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={satuan.minData.filter(
                                                          ({ CategoryID }) =>
                                                            CategoryID === "5",
                                                        )}
                                                      />
                                                    </div>
                                                  </th>
                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <input
                                                      type="text"
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Min_Usage"]
                                                      }
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Min_Usage"
                                                        ] = e.target.value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>

                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <NumberFormat
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Rate"]
                                                      }
                                                      thousandSeparator={true}
                                                      onValueChange={(
                                                        values,
                                                      ) => {
                                                        const {
                                                          formattedValue,
                                                          value,
                                                        } = values;
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Rate"
                                                        ] = value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>
                                                </tr>
                                              );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                                {quatation.dataBuilder.Activity
                                  .DetailActivity && (
                                  <div className="w-full flex flex-col justify-center items-center">
                                    <BsFileEarmarkExcelFill className="text-7xl py-2 text-gray-400" />
                                    <div className="pb-4 text-gray-800">
                                      Data tidak ditemukan
                                    </div>
                                  </div>
                                )}
                              </>
                            </Card>
                          </>
                        </div>

                        <div
                          key={index}
                          className="flex flex-wrap -mx-3 px-3 mb-6 "
                        >
                          <div
                            style={{
                              background: checkedState[index] && Colors.primary,
                            }}
                            className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-white `}
                          >
                            Vehicle Rental
                          </div>
                          <>
                            <Card className="flex flex-col items-center content-center rounded-t-none">
                              <>
                                <CardBody className="w-full pt-0 ">
                                  <div className="overflow-x-auto">
                                    <button
                                      onClick={() => handleInsertGM("Vehicle")}
                                      className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                    >
                                      Add
                                    </button>
                                  </div>
                                  <div className="overflow-x-auto">
                                    <table className="table-auto w-full bg-transparent border-collapse">
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Detail Unit
                                          </th>

                                          <th
                                            style={{ color: Colors.primary }}
                                            className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            OuM
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Min Usage
                                          </th>
                                          <th
                                            style={{ color: Colors.primary }}
                                            className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                          >
                                            Rate
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {DetailActivity &&
                                          DetailActivity.map((keyName, i) => {
                                            if (
                                              keyName["DetailUnit"] ===
                                              "Vehicle"
                                            )
                                              return (
                                                <tr key={keyName + i}>
                                                  <th>
                                                    <button
                                                      onClick={() =>
                                                        deleteGM(i)
                                                      }
                                                      className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                                    >
                                                      <BiTrash className="text-xl text-red-800" />
                                                    </button>
                                                  </th>
                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={general.minData.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            keyName["Name"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Name"] = e.value;
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["Surname"] =
                                                            e.label;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={
                                                          general.minData
                                                        }
                                                      />
                                                    </div>
                                                  </th>

                                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <div className="inline-block relative w-full  ">
                                                      <Select
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        value={satuan.minData.filter(
                                                          ({ value }) =>
                                                            value ===
                                                            data["Activity"][
                                                              index
                                                            ]["DetailActivity"][
                                                              i
                                                            ]["SatuanID"],
                                                        )}
                                                        onChange={(e) => {
                                                          let tempdata =
                                                            JSON.parse(
                                                              JSON.stringify(
                                                                data,
                                                              ),
                                                            );
                                                          tempdata["Activity"][
                                                            index
                                                          ]["DetailActivity"][
                                                            i
                                                          ]["SatuanID"] =
                                                            e.value;
                                                          UpdateQuatationDetail(
                                                            tempdata,
                                                          );
                                                        }}
                                                        options={satuan.minData.filter(
                                                          ({ CategoryID }) =>
                                                            CategoryID === "5",
                                                        )}
                                                      />
                                                    </div>
                                                  </th>
                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <input
                                                      type="text"
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Min_Usage"]
                                                      }
                                                      onChange={(e) => {
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Min_Usage"
                                                        ] = e.target.value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>

                                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    <NumberFormat
                                                      value={
                                                        data["Activity"][index][
                                                          "DetailActivity"
                                                        ][i]["Rate"]
                                                      }
                                                      thousandSeparator={true}
                                                      onValueChange={(
                                                        values,
                                                      ) => {
                                                        const {
                                                          formattedValue,
                                                          value,
                                                        } = values;
                                                        let tempdata =
                                                          JSON.parse(
                                                            JSON.stringify(
                                                              data,
                                                            ),
                                                          );
                                                        tempdata["Activity"][
                                                          index
                                                        ]["DetailActivity"][i][
                                                          "Rate"
                                                        ] = value;
                                                        UpdateQuatationDetail(
                                                          tempdata,
                                                        );
                                                      }}
                                                    />
                                                  </th>
                                                </tr>
                                              );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                                {quatation.dataBuilder.Activity
                                  .DetailActivity && (
                                  <div className="w-full flex flex-col justify-center items-center">
                                    <BsFileEarmarkExcelFill className="text-7xl py-2 text-gray-400" />
                                    <div className="pb-4 text-gray-800">
                                      Data tidak ditemukan
                                    </div>
                                  </div>
                                )}
                              </>
                            </Card>
                          </>
                        </div>
                      </>
                    );
                  }
              })}
            {checkedState[4] && (
              <div className="p-4">
                <div key={"Act"} className="flex flex-wrap -mx-3 px-3 mb-6 ">
                  <div
                    style={{
                      background: Colors.primary,
                    }}
                    className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-gray-700 hover:bg-light-blue-500 hover:text-white cursor-pointer text-white border-0 rounded-t rounded-b-none`}
                  >
                    Temporary Waste Storage
                  </div>

                  <Card className="flex flex-col items-center content-center rounded-t-none">
                    <CardBody className="w-full pt-0 ">
                      <div className="overflow-x-auto">
                        <button
                          onClick={() => handleInsertTws()}
                          className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                        >
                          Add
                        </button>
                        <table className="table-auto w-full bg-transparent border-collapse">
                          <thead>
                            <tr>
                              <th></th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Storage Location
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Unit
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Min Usage
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Rate
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data["Tws"] &&
                              data["Tws"].map((keyName, i) => (
                                <tr key={keyName + i}>
                                  <th>
                                    <button
                                      onClick={() => deleteTws(i)}
                                      className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                    >
                                      <BiTrash className="text-xl text-red-800" />
                                    </button>
                                  </th>
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <Select
                                      menuPortalTarget={document.body}
                                      value={waste.minData.filter(
                                        ({ value }) =>
                                          value === keyName["Description"],
                                      )}
                                      onChange={(e) => {
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Tws"][i]["Description"] =
                                          e.value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                      options={waste.minData}
                                    />
                                  </th>

                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <div className="inline-block relative w-full  ">
                                      <Select
                                        menuPortalTarget={document.body}
                                        value={satuan.minData.filter(
                                          ({ value }) =>
                                            value === keyName["Satuan"],
                                        )}
                                        onChange={(e) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(data),
                                          );
                                          tempdata["Tws"][i]["Satuan"] =
                                            e.value;
                                          UpdateQuatationDetail(tempdata);
                                        }}
                                        options={satuan.minData.filter(
                                          ({ CategoryID }) =>
                                            CategoryID === "4",
                                        )}
                                      />
                                    </div>
                                  </th>
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <input
                                      type="text"
                                      value={keyName["MinUsage"]}
                                      onChange={(e) => {
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Tws"][i]["MinUsage"] =
                                          e.target.value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                    />
                                  </th>

                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <input
                                      type="text"
                                      value={keyName["Rate"]}
                                      onChange={(e) => {
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Tws"][i]["Rate"] =
                                          e.target.value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                    />
                                  </th>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}
            {(checkedState[0] || checkedState[4]) && (
              <div className="p-4">
                <div key={"Act"} className="flex flex-wrap -mx-3 px-3 mb-6 ">
                  <div
                    style={{
                      background: Colors.primary,
                    }}
                    className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-gray-700 hover:bg-light-blue-500 hover:text-white cursor-pointer text-white border-0 rounded-t rounded-b-none`}
                  >
                    Equipment
                  </div>

                  <Card className="flex flex-col items-center content-center rounded-t-none">
                    <CardBody className="w-full pt-0 ">
                      <div className="overflow-x-auto">
                        <button
                          onClick={() => handleInsertEquipment()}
                          className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                        >
                          Add
                        </button>
                        <table className="table-auto w-full bg-transparent border-collapse">
                          <thead>
                            <tr>
                              <th></th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Description
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Unit
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Min Usage
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Rate
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data["Equipment"] &&
                              data["Equipment"].map((keyName, i) => (
                                <tr key={keyName + i}>
                                  <th>
                                    <button
                                      onClick={() => deleteEquipment(i)}
                                      className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                    >
                                      <BiTrash className="text-xl text-red-800" />
                                    </button>
                                  </th>
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <Select
                                      menuPortalTarget={document.body}
                                      value={kendaraan.minData.filter(
                                        ({ value }) =>
                                          value === keyName["Unit"],
                                      )}
                                      onChange={(e) => {
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Equipment"][i]["Unit"] =
                                          e.value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                      options={kendaraan.minData}
                                    />
                                  </th>
                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <div className="inline-block relative w-full  ">
                                      <Select
                                        menuPortalTarget={document.body}
                                        value={satuan.minData.filter(
                                          ({ value }) =>
                                            value === keyName["Satuan"],
                                        )}
                                        onChange={(e) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(data),
                                          );
                                          tempdata["Equipment"][i]["Satuan"] =
                                            e.value;
                                          UpdateQuatationDetail(tempdata);
                                        }}
                                        options={satuan.minData.filter(
                                          ({ CategoryID }) =>
                                            CategoryID === "1",
                                        )}
                                      />
                                    </div>
                                  </th>
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <input
                                      type="text"
                                      value={keyName["MinUsage"]}
                                      onChange={(e) => {
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Equipment"][i]["MinUsage"] =
                                          e.target.value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                    />
                                  </th>

                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <NumberFormat
                                      value={keyName["Formated"]}
                                      thousandSeparator={true}
                                      onValueChange={(values, sourceInfo) => {
                                        const { formattedValue, value } =
                                          values;

                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Equipment"][i]["Rate"] =
                                          value;
                                        tempdata["Equipment"][i]["Formated"] =
                                          value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                    />
                                  </th>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}
            {(checkedState[0] || checkedState[4]) && (
              <div className="p-4">
                <div key={"Act"} className="flex flex-wrap -mx-3 px-3 mb-6 ">
                  <div
                    style={{
                      background: Colors.primary,
                    }}
                    className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-gray-700 hover:bg-light-blue-500 hover:text-white cursor-pointer text-white border-0 rounded-t rounded-b-none`}
                  >
                    Labour
                  </div>

                  <Card className="flex flex-col items-center content-center rounded-t-none">
                    <CardBody className="w-full pt-0 ">
                      <div className="overflow-x-auto">
                        <button
                          onClick={() => handleInsertLabour()}
                          className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                        >
                          Add
                        </button>
                        <table className="table-auto w-full bg-transparent border-collapse">
                          <thead>
                            <tr>
                              <th></th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Labour
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                OuM
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Min Usage
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Rate
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data["Labour"] &&
                              data["Labour"].map((keyName, i) => (
                                <tr key={keyName + i}>
                                  <th>
                                    <button
                                      onClick={() => deleteLabour(i)}
                                      className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                    >
                                      <BiTrash className="text-xl text-red-800" />
                                    </button>
                                  </th>
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <Select
                                      menuPortalTarget={document.body}
                                      value={labour.minData.filter(
                                        ({ value }) =>
                                          value === keyName["Labour"],
                                      )}
                                      onChange={(e) => {
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Labour"][i]["Labour"] =
                                          e.value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                      options={labour.minData}
                                    />
                                  </th>
                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <div className="inline-block relative w-full  ">
                                      <Select
                                        menuPortalTarget={document.body}
                                        value={satuan.minData.filter(
                                          ({ value }) =>
                                            value === keyName["Satuan"],
                                        )}
                                        onChange={(e) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(data),
                                          );
                                          tempdata["Labour"][i]["Satuan"] =
                                            e.value;
                                          UpdateQuatationDetail(tempdata);
                                        }}
                                        options={satuan.minData}
                                      />
                                    </div>
                                  </th>
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <input
                                      type="text"
                                      value={keyName["MinUsage"]}
                                      onChange={(e) => {
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Labour"][i]["MinUsage"] =
                                          e.target.value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                    />
                                  </th>

                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <NumberFormat
                                      value={keyName["Rate"]}
                                      thousandSeparator={true}
                                      onValueChange={(values) => {
                                        const { formattedValue, value } =
                                          values;
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Labour"][i]["Rate"] = value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                    />
                                  </th>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}
            {checkedState[0] && (
              <div className="p-4">
                <div key={"Act"} className="flex flex-wrap -mx-3 px-3 mb-6 ">
                  <div
                    style={{
                      background: Colors.primary,
                    }}
                    className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-gray-700 hover:bg-light-blue-500 hover:text-white cursor-pointer text-white border-0 rounded-t rounded-b-none`}
                  >
                    Truck Entry
                  </div>

                  <Card className="flex flex-col items-center content-center rounded-t-none">
                    <CardBody className="w-full pt-0 ">
                      <div className="overflow-x-auto">
                        <button
                          onClick={() => handleInsertTruck()}
                          className="flex flex-row items-center justify-center m-2 mt-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                        >
                          Add
                        </button>
                        <table className="table-auto w-full bg-transparent border-collapse">
                          <thead>
                            <tr>
                              <th></th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Description
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Transporter
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Unit Number
                              </th>

                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Min Usage
                              </th>
                              <th
                                style={{ color: Colors.primary }}
                                className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                              >
                                Rate
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data["Truck"] &&
                              data["Truck"].map((keyName, i) => (
                                <tr key={keyName + i}>
                                  <th>
                                    <button
                                      onClick={() => deleteTruck(i)}
                                      className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
                                    >
                                      <BiTrash className="text-xl text-red-800" />
                                    </button>
                                  </th>
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <input
                                      type="text"
                                      value={keyName["Description"]}
                                      onChange={(e) => {
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Truck"][i]["Description"] =
                                          e.target.value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                    />
                                  </th>
                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <div className="inline-block relative w-full  ">
                                      <input
                                        type="text"
                                        value={keyName["Transporter"]}
                                        onChange={(e) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(data),
                                          );
                                          tempdata["Truck"][i]["Transporter"] =
                                            e.target.value;
                                          UpdateQuatationDetail(tempdata);
                                        }}
                                      />
                                    </div>
                                  </th>
                                  <th className="border-b w-1/6 border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <div className="inline-block relative w-full  ">
                                      <input
                                        type="text"
                                        value={keyName["UnitNumber"]}
                                        onChange={(e) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(data),
                                          );
                                          tempdata["Truck"][i]["UnitNumber"] =
                                            e.target.value;
                                          UpdateQuatationDetail(tempdata);
                                        }}
                                      />
                                    </div>
                                  </th>

                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <input
                                      type="text"
                                      value={keyName["MinUsage"]}
                                      onChange={(e) => {
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Truck"][i]["MinUsage"] =
                                          e.target.value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                    />
                                  </th>

                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <NumberFormat
                                      value={keyName["Rate"]}
                                      thousandSeparator={true}
                                      onValueChange={(values) => {
                                        const { formattedValue, value } =
                                          values;
                                        let tempdata = JSON.parse(
                                          JSON.stringify(data),
                                        );
                                        tempdata["Truck"][i]["Rate"] = value;
                                        UpdateQuatationDetail(tempdata);
                                      }}
                                    />
                                  </th>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}
          </div>
          <Modal
            size="md"
            active={showModal}
            toggler={() => setShowModal(false)}
          >
            <ModalHeader
              className="mt-20"
              toggler={() => {
                setShowModal(false);
              }}
            >
              Load
            </ModalHeader>
            <ModalBody>
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                <tr>
                  <th scope="col" className="py-3 px-6" key={"Header-"}>
                    Tanggal
                  </th>
                  <th scope="col" className="py-3 px-6" key={"Header-"}>
                    Nomor Kontrak
                  </th>
                  <th scope="col" className="py-3 px-6" key={"Header-"}>
                    Load
                  </th>
                </tr>
              </thead>
              <tbody>
                {load &&
                  load.map((data, id) => (
                    <tr>
                      <th
                        scope="row"
                        key={"row"}
                        className={
                          "py-4 px-6 font-medium whitespace-nowrap text-left"
                        }
                      >
                        {new Date(data.SaveDate).toString()}
                      </th>
                      <th
                        scope="row"
                        key={"row"}
                        className={
                          "py-4 px-6 font-medium whitespace-nowrap text-left"
                        }
                      >
                        {data.Data.NoKontrak}
                      </th>
                      <th
                        scope="row"
                        key={"row"}
                        className={
                          "py-4 px-6 font-medium whitespace-nowrap text-left"
                        }
                      >
                        <button
                          color={isValid ? "green" : "blueGray"}
                          ripple={isValid ? "light" : ""}
                          onClick={() => {
                            handleLoadData(data);
                          }}
                          className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded "
                        >
                          Load
                        </button>
                      </th>
                    </tr>
                  ))}
              </tbody>
            </ModalBody>
          </Modal>
        </div>
      </>
    );
  }
};

export default QuatationPage;
